<!-- Home Banner -->

<section class="banner-section">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="banner-content aos" data-aos="fade-up" data-aos-duration="2000">
          <h1>{{ 'PORTAL.HOME.TITLE.CONSULT' | translate }} <span>{{ 'PORTAL.HOME.TITLE.THE-BEST-DOCTORS' | translate }}</span> {{ 'PORTAL.HOME.TITLE.THE-CLOSEST' | translate }}</h1>
          <img src="assets/img/icons/header-icon.svg" class="header-icon" alt="header-icon"/>
          <p> {{ 'PORTAL.HOME.HOME-DETAILS.TITLE-DESCRIPTION' | translate }}</p>

        </div>
        <div
          class="search-box-one aos"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          <form [formGroup]="form">
            <div class="search-input search-line ">
              <i class="feather icon-search bficon"></i>
              <div class="mb-0">
                <input type="text" formControlName="term"  placeholder=" {{ 'PORTAL.HOME.HOME-DETAILS.SEARCH-PLACEHOLDER' | translate }}" />
              </div>
            </div>
            <div class="search-input search-map-line">
              <i class="feather icon-map-pin"></i>
              <div class="mb-0">
                <input type="text"  formControlName="emplacement" placeholder="{{ 'PORTAL.HOME.HOME-DETAILS.LOCATION-PLACEHOLDER' | translate }}"/>
                <a class="current-loc-icon current_location" href="javascript:void(0);">
                  <i class="feather icon-crosshair"></i>
                </a>
              </div>
            </div>
            <div class="form-search-btn">
              <button  (click)=" onSearch()" class="btn" type="button"  >
                  {{ 'ADMIN.BUTTONS.SEARCH-PLACE-HOLDER' | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="banner-img aos" data-aos="fade-up" data-aos-duration="2000">
          <img
            src="assets/img/banner-img.png"
            class="img-fluid"
            alt="patient-image"
          />
          <div class="banner-img1">
            <img src="assets/img/banner/banner-img1.svg" class="img-fluid" alt="checkup-image">
          </div>
          <div class="banner-img2">
            <img src="assets/img/banner/banner-img2.svg" class="img-fluid" alt="doctor-slide">
          </div>
          <div class="banner-img3">
            <img src="assets/img/banner/banner-img3.svg" class="img-fluid" alt="doctors-list">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- /Home Banner -->

<app-specialties-section></app-specialties-section>
<app-doctors-section [doctors]="doctorsList" *ngIf="doctorsList"></app-doctors-section>


<!-- Work Section -->
<section class="work-section">
  <div class="container">
    <div class="row">
      <div
        class="col-lg-4 col-md-12 work-img-info aos"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
        <div class="work-img">
          <img
            src="assets/img/work-img.png"
            class="img-fluid"
            alt="doctor-image"
          />
        </div>
      </div>
      <div class="col-lg-8 col-md-12 work-details">
        <div
          class="section-header-one aos"
          data-aos="fade-up"
          data-aos-duration="2000">
          <h5>{{ 'PORTAL.HOME.HOME-DETAILS.WORK-SECTION.TITLE' | translate }}</h5>
          <h2 class="section-title">{{ 'PORTAL.HOME.HOME-DETAILS.WORK-SECTION.TITLE-2' | translate }}</h2>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 aos" data-aos="fade-up">
            <div class="work-info">
              <div class="work-icon">
                <span
                ><img
                  src="assets/img/icons/work-01.svg"
                  alt="search-doctor-icon"
                /></span>
              </div>
              <div class="work-content">
                <h5>{{ 'PORTAL.HOME.HOME-DETAILS.WORK-SECTION.SEARSH-DOCTOR-TITLE' | translate }}</h5>
                <p>
                    {{ 'PORTAL.HOME.HOME-DETAILS.WORK-SECTION.SEARSH-DOCTOR-DESCRIPTION' | translate }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 aos" data-aos="fade-up">
            <div class="work-info">
              <div class="work-icon">
                <span
                ><img
                  src="assets/img/icons/work-02.svg"
                  alt="doctor-profile-icon"
                /></span>
              </div>
              <div class="work-content">
                <h5> {{ 'PORTAL.HOME.HOME-DETAILS.WORK-SECTION.PROFIL-DOCTOR-TITLE' | translate }} </h5>
                <p>
                    {{ 'PORTAL.HOME.HOME-DETAILS.WORK-SECTION.PROFIL-DOCTOR-DESCRIPTION' | translate }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 aos" data-aos="fade-up">
            <div class="work-info">
              <div class="work-icon">
                <span
                ><img src="assets/img/icons/work-03.svg" alt="calendar-icon"
                /></span>
              </div>
              <div class="work-content">
                <h5>{{ 'PORTAL.HOME.HOME-DETAILS.WORK-SECTION.RDV-DOCTOR-TITLE' | translate }}</h5>
                <p>
                    {{ 'PORTAL.HOME.HOME-DETAILS.WORK-SECTION.RDV-DOCTOR-DESCRIPTION' | translate }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 aos" data-aos="fade-up">
            <div class="work-info">
              <div class="work-icon">
                <span
                ><img src="assets/img/icons/work-04.svg" alt="solution-icon"
                /></span>
              </div>
              <div class="work-content">
                <h5>{{ 'PORTAL.HOME.HOME-DETAILS.WORK-SECTION.RESPONSE-DOCTOR-TITLE' | translate }}</h5>
                <p>
                    {{ 'PORTAL.HOME.HOME-DETAILS.WORK-SECTION.RESPONSE-DOCTOR-DESCRIPTION' | translate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- /Work Section -->



<!-- Partners Section -->
<section class="partners-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div
          class="section-header-one text-center aos"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          <h2 class="section-title"> {{ 'PORTAL.HOME.HOME-DETAILS.PARTNER-TITLE' | translate }}</h2>
        </div>
      </div>
    </div>
    <div class="partners-info aos" data-aos="fade-up" data-aos-duration="2000">
      <ul class="partners-slider">
        <owl-carousel-o [options]="partnersSliderOption">
          @for (data of partnersSlider; track data) {
            <ng-template carouselSlide>
              <li>
                <a href="javascript:void(0);">
                  <img class="img-fluid" [src]="data.img" alt="partners" />
                </a>
              </li>
            </ng-template>
          }
        </owl-carousel-o>
      </ul>
    </div>
  </div>
</section>
<!-- /Partners Section -->


<!-- Cursor -->
<div class="mouse-cursor cursor-outer" #cursorOuter></div>
<div class="mouse-cursor cursor-inner" #cursorInner></div>
<!-- /Cursor -->
<!-- scrollToTop start -->
<div (click)="scrollToTop()" (keydown)="scrollToTop()" tabindex="1" class="progress-wrap" [class.active-progress]="strokeValue < progress">
  <svg class="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" style="transition: stroke-dashoffset 10ms linear 0s"
          attr.stroke-dasharray="{{ progress + 'px' + ',' + progress + 'px' }}"
          attr.stroke-dashoffset="{{ strokeValue + 'px' }}"></path>
  </svg>
</div>
<!-- scrollToTop end -->
